import PromotionBannerCreate from './Create'
import PromotionBannerEdit from './Edit'
import PromotionBannersList from './List'

const promotionBannersResource = {
  list: PromotionBannersList,
  create: PromotionBannerCreate,
  edit: PromotionBannerEdit,
}

export default promotionBannersResource
